import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  OnDestroy,
  NgZone,
} from "@angular/core";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import { EventInput, Calendar } from "@fullcalendar/core";
import { SupportService } from "../services/support-service";
import { ScheduleSharedService } from "../services/schedule-shared.service";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { DatePipe } from "@angular/common";
import { environment } from "src/environments/environment";

const days: any = [
  { id: 1, name: "monDay", value: "Monday" },
  { id: 2, name: "tueDay", value: "Tuesday" },
  { id: 3, name: "wedDay", value: "Wednesday" },
  { id: 4, name: "thuDay", value: "Thursday" },
  { id: 5, name: "friDay", value: "Friday" },
  { id: 6, name: "satDay", value: "Saturday" },
  { id: 0, name: "sunDay", value: "Sunday" },
];
@Component({
  selector: "app-home-calender",
  templateUrl: "./home-calender.component.html",
  providers: [DatePipe],
})
export class HomeCalenderComponent implements OnInit, OnDestroy {
  today: any = new Date();
  eventApiData: any;
  equipmentData: any;
  equipmentDataList = [];
  eventCalenderData: EventInput[] = [];
  patientID = "";
  patientName = "";
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  isModel = false;
  patientDetails: any = {};
  calender;
  mintime = "00:00";
  maxTime = "23:59";
  workingHours: any = [];
  @ViewChild("PatientModal") PatientModal: TemplateRef<any>;
  unsub: Subscription;
  isResource = false;
  calendarResourceList: any = [];
  availableTechList: any = [];
  showTechListDropDown = false;
  selectedScheduleId = "";
  newTechId = "";
  tcCountryCode = "";
  constructor(
    private appservice: AppService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private zone: NgZone,
    private modalService: BsModalService,
    private supportService: SupportService,
    private ngxService: NgxUiLoaderService,
    public datepipe: DatePipe,
    private scheduleShared: ScheduleSharedService
  ) {
    this.scheduleShared.registerAngularComponentRef(this);
  }

  navigate(val) {
    const res = val.split("/");
    if (res.length > 0) {
      if (res[1] === "patient") {
        setTimeout(() => {
          if (this.isModel === false) {
            this.patientID = res[2];
            this.patientName = res[3];
            this.appservice
              .viewscheduleappointmentproWithFlag(this.patientID)
              .subscribe((scheduleDetail: any) => {
                if (scheduleDetail.status.status === 200) {
                  this.selectedScheduleId = scheduleDetail.entity.schedule.id;

                  this.patientDetails = {};
                  this.patientDetails = scheduleDetail.entity.schedule;
                  
                  if (
                    !scheduleDetail.entity.schedule.physicianFirstName ||
                    !scheduleDetail.entity.schedule.physicianLastName
                  ) {
                    this.getAvailableTechnician();
                  }
                  if (
                    scheduleDetail.entity.procedures &&
                    scheduleDetail.entity.procedures.length > 0
                  ) {
                    this.patientDetails.bodyPartName =
                      scheduleDetail.entity.procedures[0].bodyPartName;
                    this.patientDetails.procedureName =
                      scheduleDetail.entity.procedures[0].procedureName;
                  }
                  if (
                    scheduleDetail.entity.schedProEquips &&
                    scheduleDetail.entity.schedProEquips.length > 0
                  ) {
                    this.patientDetails.technicianFirstName =
                      scheduleDetail.entity.schedProEquips[0].technicianFirstName;
                    this.patientDetails.technicianLastName =
                      scheduleDetail.entity.schedProEquips[0].technicianLastName;
                  }
                  
                  setTimeout(() => {
                    if (this.modalService.getModalsCount() === 0) {
                      this.openModal(this.PatientModal);
                    }
                  }, 252);
                }
              });
          }
        }, 252);
      } else {
        this.zone.run(() => {
          const obj = this;
          if (obj.schedulerelatedMenu) {
            this.isModel = true;
            this.router.navigate([val]);
          }
        });
      }
    }
  }

  accessmanagement: any = [];

  ngOnInit() {
    this.ngxService.start();
    setTimeout(() => {
      this.ngxService.stop();
    }, 1000);

    this.accessmanagement = JSON.parse(
      localStorage.getItem("accessmanagement")
    );
    if (this.accessmanagement) {
      this.setaccessmanagement(this.accessmanagement);
    } else {
      this.getAccessManagement();
    }

    sessionStorage.setItem("type", "Dashboard");
    this.supportService.headerSubLittle.next("Home");
    this.unsub = this.supportService.getDateChange1.subscribe((data) => {
      if (data && data.type === "emit") {
        this.supportService.getDateChange1.next("");
        this.today = data.date;
        if (!this.cd["destroyed"]) {
          this.cd.detectChanges();
        }
        this.getEventDayDate();
      }
    });
    localStorage.removeItem("patientID");
  }

  accessManagement: any = [];
  accessManagements: any = [];
  getAccessManagement() {
    this.appservice.getFrontDeskAccessManagement().subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        this.accessManagement = res["entity"];
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy =
            res["entity"][index]["accessManagement"]["accessType"];
          this.accessManagements[index] = res["entity"][index];
          this.accessManagements[index].groupBy = groupBy
            .toString()
            .substring(0, 11);
        }
        this.accessManagement = this.groupBy(this.accessManagements, "groupBy");
        this.setaccessmanagement(this.accessManagement);
      }
    });
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  schedulerelatedMenu = false;
  messageCenterMenu = false;
  setaccessmanagement(value) {
    if (value) {
      for (let index = 0; index < value.length; index++) {
        if (value[index] !== null && value[index].key === "Operations") {
          for (let j = 0; j < value[index].value.length; j++) {
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Schedule Appointments"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.schedulerelatedMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.schedulerelatedMenu = true;
              }
            }

            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Message Center"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.messageCenterMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.messageCenterMenu = value[index].value[j].admin;
              }
            }
          }
        }
      }
    }
  }

  showTechDropDown() {
    this.showTechListDropDown = true;
  }

  getAvailableTechnician() {
    this.appservice
      .getavailabletechnicianhomecal(this.selectedScheduleId)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.availableTechList = res["entity"];
          } else {
            this.availableTechList = [];
          }
        } else {
          this.availableTechList = [];
        }
      });
  }

  assignNewTechForSchedule(techId) {
    this.appservice
      .assigntechnicianforschedule(techId, this.selectedScheduleId)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.modalRef.hide();
          this.ngOnInit();
        }
      });
  }

  viewTestCenter() {
    this.appservice
      .checkGivenDateIsHolidayOrNot(
        this.getMonthNumberBymonthName(this.calendarTitle)
      )
      .subscribe((res) => this.scheduleShared.applyHolidayCheckResult(this, res));
  }

  formateMask(phonecode) {
    if (phonecode) {
      if (phonecode === "+91" || phonecode === +91) {
        return environment.indiaPhoneMask;
      } else {
        return environment.usPhoneMask;
      }
    }
  }

  setCalendarTime(work) {
    this.scheduleShared.setCalendarTime(this, days, work);
  }

  closeModal() {
    this.modalRef.hide();
    this.isModel = false;
  }

  openModal(template: TemplateRef<any>) {
    this.PatientModal.createEmbeddedView(null);
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  gotoLeft() {
    if (this.calender) {
      this.calender.prev();
      this.today = new Date(this.today.setDate(this.today.getDate() - 1));
      this.calendarTitle = this.calender.view.title;
      this.supportService.getDateChange.next({
        date: true,
        dateVal: this.today,
      });
    }
  }

  gotoRight() {
    if (this.calender) {
      this.calender.next();
      this.today = new Date(this.today.setDate(this.today.getDate() + 1));
      this.calendarTitle = this.calender.view.title;
      this.supportService.getDateChange.next({
        date: true,
        dateVal: this.today,
      });
    }
  }

  calenderView() {
    const calendarEl = document.getElementById("home-calendar");
    calendarEl.innerHTML = "";
    const calender = new Calendar(calendarEl, {
      schedulerLicenseKey: "0569894629-fcs-1563784117",
      plugins: [resourceTimeGridPlugin],
      defaultView: "resourceTimeGridDay",
      timeZone: "UTC",
      allDaySlot: false,
      resources: this.equipmentDataList,
      eventRender: this.eventChange,
      header: false,
      minTime: this.mintime,
      maxTime: this.maxTime,
    });
    calender.gotoDate(this.datepipe.transform(this.today, "yyyy-MM-dd"));
    calender.render();
    return calender;
  }

  calendarTitle: any = null;
  eventChange(event) {
    const element = event.el as HTMLElement;
    const tcID = localStorage.getItem("testCode");
    if (event.event.extendedProps.customId) {
      element.innerHTML = `
      <div class="fc-content" >
      <div class="fc-title"  onclick='angularComponentRef.componentFn
      (\"/patient/${event.event.extendedProps.customId}/${
        event.event.extendedProps.patientFirstName
      } ${event.event.extendedProps.patientLastName}\")'
       ondblclick='angularComponentRef.componentFn
      (\"/${tcID}/check-in-patient/${event.event.extendedProps.customId}\")'>
      ${event.event.extendedProps.patientFirstName}  ${
        event.event.extendedProps.patientLastName
      }
      ${
        event.event.extendedProps.procedureName
          ? " <br/>" + event.event.extendedProps.procedureName
          : ""
      }
      <br/> ${event.event.extendedProps.eventStartTime} - ${
        event.event.extendedProps.eventEndTime
      }
      </div>
      </div>
      `;
    } else {
      if (event.event.title === "Lunch") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title">
        Lunch  <br/>
        ${event.event.extendedProps.eventStartTime} ${event.event.extendedProps.eventEndTime}
        </div>
        </div>
        `;
      } else if (event.event.title === "Holiday") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title">
        Closed
        </div>
        </div>
        `;
      } else if (event.event.title === "Weekoff") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title">
        Closed
        </div>
        </div>
        `;
      }
    }
  }

  getToday() {
    this.today = new Date();
    this.supportService.getDateChange.next({ date: true, dateVal: this.today });
  }

  gotoPage(page) {
    if(page === 'schedule-appointment'){
      sessionStorage.setItem("scheduleData","");
      sessionStorage.setItem("waitinglistdata","")
    }
    const tcID = localStorage.getItem("testCode");
      this.supportService.sidemenuname.next(`/${tcID}/${page}`);
      this.router.navigateByUrl(`/${tcID}/${page}`);
  }

  getEventDayDate() {
    if (this.isResource === false) {
      const tcID = localStorage.getItem("testCenterId");
      const data1 = {
        testCenterId: tcID,
        available: true,
      };

      this.appservice.getAllEquipmentsBTcCalendar(data1).subscribe(
        (res) => {
          this.equipmentData = res;
          this.equipmentData = this.equipmentData.entity;
          this.equipmentDataList = [];
          this.equipmentData.forEach((obj) => {
            this.equipmentDataList.push({ id: obj.mac, title: obj.mac });
          });
          this.isResource = true;
          this.getEvents();
        },
        (err) => {
          if (err.error.error === "invalid_token") {
            this.appservice.sessionOut(err);
          }
        }
      );
    } else {
      this.getEvents();
    }
  }

  getMonthNumberBymonthName(valuearray): string {
    return this.scheduleShared.getMonthNumberBymonthName(valuearray);
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  convert24to12(value): string {
    let timevalue = "";
    const concat = value.toString().split(":");
    let time;
    // Check correct time format and split into components
    if (concat && concat.length > 0) {
      time = concat[0] + ":" + concat[1];
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      timevalue = time.join(""); // return adjusted time or original string
    }
    return timevalue;
  }

  getEvents() {
    this.calender = this.calenderView();

    this.calendarTitle = this.calender.view.title;

    this.tcCountryCode = localStorage.getItem("country_code")
      ? localStorage.getItem("country_code")
      : "US";

    const data = {
      startDate: this.getMonthNumberBymonthName(this.calendarTitle),
      type: "day",
    };

    this.appservice.gettcschedulebydatetype(data).subscribe((res) => {
      this.eventApiData = res;
      this.eventApiData = this.eventApiData.entity;
      const calender = this.calenderView();
      const eventList: any = [];
      if (this.eventApiData) {
        if (this.eventApiData.length > 0) {
          this.eventApiData.forEach((obj) => {
            const event: any = {};
            event.customId = obj.scheduleAppointmentId;
            event.resourceId = obj.equipmentMac;
            event.title =
              obj.examShortname +
              " - " +
              obj.bodyPart +
              " - " +
              obj.procedureName;
            event.start = obj.scheduledOnStr + "T" + obj.fromTime + "+00:00";
            event.end = obj.scheduledOnStr + "T" + obj.toTime + "+00:00";
            event.eventStartTime = this.convert24to12(obj.fromTimeStr);
            event.eventEndTime = this.convert24to12(obj.toTimeStr);
            event.procedureName = obj.procedureName;
            event.patientFirstName = obj.patientFirstName;
            event.patientLastName = obj.patientLastName;
            event.patientId = obj.patientId;
            event.textColor = "white";

            if (this.tcCountryCode === "IN") {
              if (obj.technicianId === null || obj.technicianId === "") {
                event.className = "cal-more-border";
              }

              if (obj.patientCheckIn === true) {
                event.color = "#C8C8C8";
                event.className = "";
              } else if (
                obj.schedMed === true &&
                (obj.patientType === "Sched" || obj.patientType === "Mobile")
              ) {
                event.color = "#1F497D";
              } else if (obj.schedMed === true && obj.patientType === "IC") {
                event.color = "#646464";
              }
            } else if (this.tcCountryCode === "US") {
              if (obj.technicianId === null || obj.technicianId === "") {
                event.className = "cal-more-border";
              }
              if (obj.patientCheckIn === true) {
                event.color = "#C8C8C8";
                event.className = "";
              } else if (
                obj.preAuthorized === false &&
                obj.schedMed === true &&
                (obj.patientType === "Sched" || obj.patientType === "Mobile")
              ) {
                event.color = "#00B0F0";
              } else if (
                obj.preAuthorized === false &&
                obj.schedMed === true &&
                obj.patientType === "IC"
              ) {
                event.color = "#969696";
              } else if (
                obj.preAuthorized === true &&
                obj.schedMed === true &&
                (obj.patientType === "Sched" || obj.patientType === "Mobile")
              ) {
                event.color = "#1F497D";
              } else if (
                obj.preAuthorized === true &&
                obj.schedMed === true &&
                obj.patientType === "IC"
              ) {
                event.color = "#646464";
              }
            }
            eventList.push(event);
          });
        }
      }
      if (eventList.length > 0) {
        calender.addEventSource(eventList);
      }
      this.calender = calender;
      this.viewTestCenter();
    });
  }

  formatHomeDate(date) {
    return this.scheduleShared.formatHomeDate(date);
  }

  getInsurance(type) {
    return this.scheduleShared.getInsurance(type);
  }

  convertTime12to24 = (time12h) =>
    this.scheduleShared.convertTime12to24(time12h);

  ngOnDestroy() {
    this.unsub.unsubscribe();
    this.cd.detach();
    if (this.calender) {
      this.calender.destroy();
    }
  }
}
